import { Component } from '@angular/core';
import { ModalService } from 'src/app/shared/components/modal/modal.service';
import { AuthService } from 'src/app/shared/utils/services/auth.service';
import { IUser } from 'src/app/core/models/user.model';

@Component({
  selector: 'app-end-list-modal',
  templateUrl: './end-list-modal.component.html',
  styleUrls: ['./end-list-modal.component.scss']
})
export class EndListModalComponent {

  private user: IUser;
  public data: any;

  constructor(
    private modal: ModalService,
    private authService: AuthService
  ) { 
    this.user = this.authService.getUser();
  }

  onClose() {
    this.modal.closeModal();
    if (!this.data) {
      document.location.reload();
    }
  }
}
